import { Quote } from "lucide-react";
import { GoogleRating } from "@/components/GoogleRating";
import { TESTIMONIALS } from "@/lib/data";

const TRUST = ["Independent brokerage", "50+ A-rated carriers", "2,000+ clients served annually", "$150M+ protected"];

export const FunnelProof = ({ product }) => {
  const t = TESTIMONIALS.find((x) => x.quote.includes(product.tag)) || TESTIMONIALS[0];
  return (
    <section className="bg-[#F0EBE0] grain border-y border-[#0B132B]/6">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-8">
            <Quote data-reveal size={40} className="text-[#29ABE2] fill-[#29ABE2]/20 mb-6" />
            <blockquote
              data-reveal
              data-testid="funnel-testimonial"
              className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-[#0B132B]"
            >
              "{t.quote}"
            </blockquote>
            <p data-reveal className="mt-6 text-sm sm:text-base text-[#334155]">
              <span className="font-semibold text-[#0B132B]">{t.name}</span> · {t.role}
            </p>
          </div>
          <div data-reveal className="lg:col-span-4">
            <div className="rounded-3xl bg-white border border-[#0B132B]/6 p-6 md:p-8">
              <GoogleRating />
              <ul className="mt-6 space-y-3">
                {TRUST.map((x) => (
                  <li key={x} className="flex items-center gap-3 text-sm md:text-base text-[#0B132B] font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#29ABE2]" /> {x}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
